export default "__VITE_ASSET__CnZRI_SL__"